// extracted by mini-css-extract-plugin
export var button = "_fd-0";
export var donut = "_fd-1";
export var donutFill = "_fd-3";
export var donutTrack = "_fd-2";